import type { SlackAppHealth } from "@/types/admin/slack-apps";

const NEUTRAL = "bg-gray-100 text-gray-700";
const WARNING = "bg-genie-secondary/10 text-genie-secondary";

export const SLACK_APP_HEALTH: Record<SlackAppHealth, { label: string; hint: string; badge: string }> = {
  failing: {
    label: "Failing",
    hint: "The last thing we heard was a failure. It clears when Slack next reaches us with a valid request. Anyone with the webhook URL can trigger a signature failure, so check the app before treating it as broken.",
    badge: "bg-red-600 text-white",
  },
  needs_update: {
    label: "Needs update",
    hint: "The app is behind our current manifest or scopes. Its owner sees a notice in the Share drawer.",
    badge: WARNING,
  },
  not_installed: {
    label: "Not installed",
    hint: "The app was set up, but no workspace has it now.",
    badge: WARNING,
  },
  setup_unfinished: {
    label: "Setup unfinished",
    hint: "The owner started the setup, but no install has succeeded yet.",
    badge: NEUTRAL,
  },
  plan_lapsed: {
    label: "Plan lapsed",
    hint: "The app keeps running, but its owner no longer has a paid plan.",
    badge: NEUTRAL,
  },
  quiet: {
    label: "Quiet",
    hint: "Nothing from Slack for 30 days. Nobody may be using it, or the app may have been deleted. It's worth a look, not proof it's broken.",
    badge: NEUTRAL,
  },
  healthy: {
    label: "Healthy",
    hint: "Installed, with no recent failures.",
    badge: "bg-genie-primary/10 text-genie-primary",
  },
};
